import { ServerConfig } from "@/config/config";
import { Admin } from "@/models/admin";
import { Axios } from "@/services/auth-service";

export class AdminsServiceClass{
	private readonly URL = `${ServerConfig.host}/admin/admins`;
	public admins:Admin[] = [];

	async getAdmins():Promise<Admin[]> {
		if (this.admins.length > 0) {
			return this.admins.filter((a) => a.name != "");
		}
		let result = await Axios.get(`${this.URL}`);
		this.admins = result.data.map((a:any) => new Admin(a));
		return this.admins.filter((a) => a.name != "");
	}

	async setPermissions(adminId:number, permissions:string[]):Promise<Admin>{
		let result = await Axios.post(`${this.URL}/${adminId}/set-permissions`, permissions);
		return new Admin(result.data);
	}
}

export const AdminsService = new AdminsServiceClass();